/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { find } from "lodash";
import { ContentZoneLayout } from "cms/components/layout/content-zone-layout";
import { isStringNotEmpty, objectHasPropertyArray } from "utils/empty-exists";
import { Logger } from "cms/utils/log/logger";
import "./component.types";
import { componentTypes } from "./component-config";

// TODO: Need to better combine this data with component config from DB
//       with the goal of removing this config, if possible

/**
 * getComponentConfig
 * A function used to return a component config, when supplied a component type string. 
 * @param type
 * @returns {SimpliCityComponentConfig}
 */
function getComponentConfig (type) {

    if (!isStringNotEmpty(type)) {
        throw Error("could not get Component Configuration due to missing type.");
    }
    const componentConfig = find(componentTypes, (config) => {
        if (objectHasPropertyArray(config, "types")) {
            return config.types.includes(type);
        }
        return config.type === type;
    });

    if (!componentConfig) {
        Logger.error(`Could not get configuration for component type: ${type}`);
    } else {
        return componentConfig;
    }
}


/**
 * This a factory method that returns a component based on the type. It is
 * used in content-zone-edit where we are looping through content records each
 * with a given type.
 *
 * @param type
 * @returns {FC}
 */
export const getComponentByType = (type) => {
    const componentConfig = getComponentConfig(type);
    const { component = null } = componentConfig || {};
    return component;
};

/**
 * getDefaultImpl 
 * returns a JSON object with the default state of a component as JSON data.
 * @param type
 * @returns {SimpliCityComponentDefaultImpl}
 */
export const getDefaultImpl = (type) => {
    if (!isStringNotEmpty(type)) {
        throw Error("could not get Component Default Implementation due to missing type.");
    }
    const componentConfig = getComponentConfig(type);
    return { ...componentConfig?.defaultImpl, type };
};

/**
 * getComponentZoneLayout
 * Returns a JSX component that represents both edit and display modes of a SimpliCity Component
 * @param {SimpliCityComponentZoneProps} props
 * @returns {JSX.Element}
 */
export const getComponentZoneLayout = (props) => {

    const fieldName = props?.fieldname;
    const displayComponent = props?.displayComponent;
    const editComponent = props?.editComponent;
    const webpage = props?.webpage;
    const component = props?.component;
    const type = props?.type ? props?.type : component?.type;
    const position = props?.position ? props?.position : component?.position;
    // const type = component?.type
    // const position = component?.position
    const index = props?.index;
    const count = props?.count;
    const hide = props?.hide;
    const editMode = props?.editMode;
    const contentOnly = props?.contentOnly;
    
    return (
        <ContentZoneLayout
            fieldName={fieldName}
            type={type}
            displayComponent={displayComponent}
            editComponent={editComponent}
            position={position}
            index={index}
            webpage={webpage}
            component={component}
            count={count}
            hide={hide}
            editMode={editMode}
            contentOnly={contentOnly}
        />
    );
};
